<div class="auth-container">
  <div class="auth-card">
    <div class="auth-header">
      <h2>Reset Password</h2>
      <p>Create a new strong password</p>
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="password">New Password</label>
        <div class="password-input-wrapper">
          <input id="password" type="password" formControlName="password" placeholder="New password"
            [class.invalid]="resetForm.get('password')?.invalid && resetForm.get('password')?.touched">
        </div>

        <div class="password-criteria">
          <div class="criteria-item" [class.valid]="hasMinLength">
            <span class="icon">{{ hasMinLength ? '✓' : '○' }}</span> At least 8 characters
          </div>
          <div class="criteria-item" [class.valid]="hasUpperCase">
            <span class="icon">{{ hasUpperCase ? '✓' : '○' }}</span> At least 1 uppercase letter
          </div>
          <div class="criteria-item" [class.valid]="hasLowerCase">
            <span class="icon">{{ hasLowerCase ? '✓' : '○' }}</span> At least 1 lowercase letter
          </div>
          <div class="criteria-item" [class.valid]="hasNumber">
            <span class="icon">{{ hasNumber ? '✓' : '○' }}</span> At least 1 number
          </div>
          <div class="criteria-item" [class.valid]="hasSpecialChar">
            <span class="icon">{{ hasSpecialChar ? '✓' : '○' }}</span> At least 1 special character (!@#$%^&*)
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <input id="confirmPassword" type="password" formControlName="confirmPassword" placeholder="Confirm new password"
          [class.invalid]="resetForm.get('confirmPassword')?.invalid && resetForm.get('confirmPassword')?.touched">
      </div>

      <button type="submit" [disabled]="resetForm.invalid || isLoading" class="btn-primary">
        <span *ngIf="!isLoading">Reset Password</span>
        <span *ngIf="isLoading">Resetting...</span>
      </button>

      <div *ngIf="errorMessage" class="error-alert">
        {{ errorMessage }}
      </div>
      <div *ngIf="successMessage" class="success-alert">
        {{ successMessage }}
      </div>
    </form>
    <div class="auth-footer" *ngIf="successMessage">
      <p><a routerLink="/login">Proceed to Login</a></p>
    </div>
  </div>
</div>